// extracted by mini-css-extract-plugin
export var divider = "_33-0";
export var dividerText = "_33-1";